// extracted by mini-css-extract-plugin
export default {"h2":"Header_h2__7QBsu","h3":"Header_h3__kHxmW","h4":"Header_h4__ZjnVO"};